/** Word-overlap (Jaccard) similarity between two human-written names, used to
 * decide whether two labels refer to the same machining operation. Single
 * characters are dropped so a stray "1" or "a" cannot carry a match. */
export function nameSimilarity(a: string, b: string): number {
  const words = (s: string) =>
    new Set(
      s
        .toLowerCase()
        .split(/[^a-z0-9]+/i)
        .filter((w) => w.length > 1)
    );
  const wa = words(a);
  const wb = words(b);
  if (wa.size === 0 || wb.size === 0) return 0;
  let shared = 0;
  wa.forEach((w) => {
    if (wb.has(w)) shared += 1;
  });
  return shared / new Set([...wa, ...wb]).size;
}
